import { Box, IconButton, List, ListItem, ListItemButton, ListItemIcon } from '@mui/material'
import classNames from 'classnames/bind'
import styles from './NavbarSearch.module.scss'
import { currentTheme, drawerSetting } from '~/redux/features'
import { useAppSelector } from '~/app/hooks'
import { ALL_NS } from '~/i18n/namespaces'
import { useTranslation } from 'react-i18next'
import { SearchIcon } from '~/components/EFIcons'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { IDeviceSearchRequest } from '~/models'
import { useNavigate } from 'react-router-dom'
import { PATH_NAME } from '~/constants/paths'

const cx = classNames.bind(styles)

interface INavbarSearchProps {
  handleClickSearchButton: () => void
}
export const NavbarSearch = ({ handleClickSearchButton }: INavbarSearchProps) => {
  const { isShowDrawer } = useAppSelector(drawerSetting)
  const theme = useAppSelector(currentTheme)
  const { t } = useTranslation(ALL_NS)
  const navigate = useNavigate()

  const methods = useForm<IDeviceSearchRequest>()
  const { reset, handleSubmit, register } = methods
  const onSubmitHandler: SubmitHandler<IDeviceSearchRequest> = values => {
    navigate(`${PATH_NAME.SEARCH_TERMS_PAGE.path + values.searchTerms}`)
    reset(values)
  }
  return (
    <List className={cx('search-wrapper')}>
      {isShowDrawer ? (
        <ListItem
          title={t('Label_SearchAllDevicesAndGroups')}
          className={cx('nav-search', theme)}
        >
          <ListItemButton className={cx('inner')}>
            <ListItemIcon className={cx('icon-search')}>
              <IconButton
                id='btn-search-device'
                className='search-icon-button'
                role='input'
                type='submit'
                form='search-form'
              >
                <SearchIcon
                  height={25}
                  width={25}
                />
              </IconButton>
            </ListItemIcon>
            <FormProvider {...methods}>
              <Box
                component='form'
                id='search-form'
                onSubmit={handleSubmit(onSubmitHandler)}
                sx={{ width: '100%' }}
              >
                <input
                  {...register('searchTerms')}
                  type='text'
                  autoComplete='off'
                  placeholder={t('Label_SearchAllDevicesAndGroups')}
                ></input>
              </Box>
            </FormProvider>
          </ListItemButton>
        </ListItem>
      ) : (
        <ListItem
          title={t('Label_SearchAllDevicesAndGroups')}
          className={cx('search-button-wrapper')}
        >
          <div className={cx('search-button', theme)}>
            <IconButton
              id='btn-search-small'
              onClick={handleClickSearchButton}
              className={cx('search-icon-button', theme)}
            >
              <SearchIcon />
            </IconButton>
          </div>
        </ListItem>
      )}
    </List>
  )
}
